export default "__VITE_ASSET__ccd0b8a2__"